import type { ComparatorResult } from "./comparatorResult";

export function stringComparator(value1: string, value2: string): ComparatorResult {
  return value1.toLocaleLowerCase().localeCompare(value2.toLocaleLowerCase());
}
